const workdayReportSettingsLinks: any[] = [
  {
    label: "MENU.CATEGORIES_EXTRA_HOURS",
    capability: "show_menu_categories_extra_hours",
    url: "/dashboard/workday-report/categories-list",
    section: "lists", // lists, update_data, administration, documents, notifications, manage_platform, user_permissions
  },
  {
    label: "MENU.WORKDAY_USERS_REPORTS",
    capability: "show_menu_user_report_list",
    url: "/dashboard/workday-report/users-reports",
    section: "administration", // lists, update_data, administration, documents, notifications, manage_platform, user_permissions
  },
  {
    label: "MENU.WORKDAY_COLLABORATORS_REPORTS",
    capability: "show_menu_user_report_list",
    url: "/dashboard/workday-report/collaborators-by-providers-reports",
    section: "administration", // lists, update_data, administration, documents, notifications, manage_platform, user_permissions
  },
];
export default workdayReportSettingsLinks;
